import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { ApiContext } from '../../../UseContext/ApiCall';


const CnpSelectCollagePopup = () => {

  const {
    setShowCreateNewPostPopup,
    setCnpPreviouslyOpenedPopup,

    showCnpSelectCollagePopup, setShowCnpSelectCollagePopup,
    collageLayouts,
    handleSelectCollageLayout,
  } = useContext(ApiContext);


  // handle close select collage popup
  const handleCloseSelectCollagePopup = () => {
    setShowCnpSelectCollagePopup(false);
    setShowCreateNewPostPopup(true);
    setCnpPreviouslyOpenedPopup('createNewPost');
  };


  return (
    <>
      <Modal show={showCnpSelectCollagePopup} onHide={handleCloseSelectCollagePopup} centered backdrop="static" keyboard={false} className="main-modal" >
      {/* <Modal show={true} onHide={handleCloseSelectCollagePopup} centered backdrop="static" keyboard={false} className="main-modal" > */}
        <Modal.Header className='mb-5 pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3 mb-0'>Select Collage</h5>
        </Modal.Header>

        <Modal.Body className='pt-1'>
          {/* Collage Layouts */}
          <div className="border d-flex flex-wrap gap-3 gap-sm-4 overflow-y-scroll p-2" style={{ height: '50vh' }}>
            {
              collageLayouts.map((layout, index) => (
                <div className='cursor-pointer' style={{ width: `${parseFloat(layout.width) * 2}px` }} key={index} >
                  {
                    layout.layout.map((cols, i) => (
                      <div className='d-flex' style={{ height: `${parseFloat(layout.height[i]) * 2}px` }} key={i}>
                        {
                          Array(cols).fill(0).map((_, j) => (
                            <div onClick={() => handleSelectCollageLayout(layout)} style={{ flex: 1, border: '1px solid black' }} key={j} />
                          ))
                        }
                      </div>
                    ))
                  }
                </div>
              ))
            }
          </div>
        </Modal.Body>
      </Modal>  
    </>
  );
};

export default CnpSelectCollagePopup;